import ready, { HTML } from './_utils';
import initMobileNav from './_components/mobileBurger';
import initOpenClose from './_components/openClose';
import initFancybox from './_components/fancybox';
import cookieConsent from './_components/cookieConsent';
import './_plugins/inViewport';
import initAnchors from './_components/anchor';
import VodaAnimations from './_components/animations';
import fullpage from "fullpage.js"
// import PanelSnap from 'panelsnap';


console.log("VODA.ai loaded");
ready(() => {
	try{
		HTML.classList.add('is-loaded');
		VodaAnimations.init();
		let isMobile = (jQuery('.mobile-detect').css('display') == 'block');

		if(isMobile){
			// jQuery('#mega-menu .open-close-menu').first().find('.open-close-menu__opener').addClass("default-open").trigger('click');
			jQuery('#mega-menu .open-close-menu').first().addClass("active").addClass("default-open").find('.menu-drop').removeClass("js-slide-hidden");
		}


		initMobileNav();
		initOpenClose();
		initFancybox();
		// cookieConsent.init();
		initAnchors();


		if(jQuery('.page-home').length >= 1){
			if(!isMobile){
				new fullpage('.page-home .content-page', {
					licenseKey: '3K7LI-9NP3I-6LK6J-J85H6-VKXUP',
					autoScrolling:true,
					scrollBar: true,
					navigation: false,
					responsiveWidth: 800,
					fitToSection: false,
					scrollHorizontally: false,
					sectionSelector: 'section'
				});
			}
		}


		if(jQuery('.slider-block').length >= 1){
			jQuery(".slider-block .slider").on("init", function(event, slick){
				jQuery(this).parent().find('.indicator').text(parseInt(slick.currentSlide + 1) + ' of ' + slick.slideCount);
			});

			jQuery(".slider-block .slider").on("afterChange", function(event, slick, currentSlide){
				jQuery(this).parent().find('.indicator').text(parseInt(slick.currentSlide + 1) + ' of ' + slick.slideCount);
			});

			jQuery('.slider-block .slider').slick({
				dots: false,
				infinite: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: false,
				// adaptiveHeight: false,
				nextArrow: jQuery(".slider-block .next-btn"),
				prevArrow: jQuery(".slider-block .prev-btn"),
				cssEase: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)',
				speed: 500
			});
		}


		jQuery(document).on('nfFormReady', function(){
			jQuery('.nf-field-element input, .nf-field-element select, .nf-field-element textarea').on("focus", function(){
				jQuery(this).parent().parent().find("label").addClass("input-active");
			}).on("focusout", function(){
				if(jQuery(this).val() == ""){
					jQuery(this).parent().parent().find("label").removeClass("input-active");
				}
			});
		});

		jQuery('.track-in-viewport, .top-of-main').itemInViewport({
			once: false,
			visibleMode: 3,
		});

		jQuery('.content-page section').first().append('<a class="scroll-after-hero" href="#after-hero"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><g id="baseline-arrow_forward_ios-24px" transform="translate(48) rotate(90)"><path id="Path_1982" data-name="Path 1982" d="M5.88,6.24,21.64,22,5.88,37.76,10.12,42l20-20-20-20Z" transform="translate(5.88 2)" fill="#fff"/><path id="Path_1983" data-name="Path 1983" d="M0,0H48V48H0Z" fill="none"/></g></svg></a>');

		jQuery("body").on('click tap', '.scroll-after-hero', function(e){
			var secondSection = jQuery('.content-page section')[1];
			jQuery('html,body').animate({scrollTop: jQuery(secondSection).offset().top}, 'slow');
			e.preventDefault();
		});

		//pricing form logic check
		jQuery(document).on('nfFormReady', function(){
			if(typeof window.Marionette !== 'undefined'){
				var Marionette = window.Marionette;
				var Backbone = window.Backbone;
				var pricingForm = Marionette.Object.extend({
					initialize: function(formModel){
						var form = this;

						var fieldsChannel = Backbone.Radio.channel('fields');
						this.listenTo(fieldsChannel, 'change:modelValue', this.validate);
					},
					validate: function(model){
						//gis yes,no
						if(model.get('id') === 7){
							var value = model.get('value');
							if(value === "no"){
								jQuery("#nf-field-7-container").hide();
							}
						}
						if(model.get('id') === 13){
							var value = model.get('value');
							if(value === "no"){
								jQuery("#nf-field-13-container").hide();
								jQuery('.nf-next-previous').hide();
							}
						}

					}
				});
				new pricingForm();
			}
		});

		//faq items
		jQuery(".accordion-item").on('click tap', function(e){
			e.preventDefault();
			var active = false;
			if(jQuery(this).hasClass("active")){
				active = true;
				jQuery(this).removeClass("active");
			}else{
				jQuery(this).addClass("active");
			}
		});

		//for firefox specific CSS
		if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
			jQuery('body').addClass("is-firefox");
	   	}
	}catch(e){
		console.error(e);
		//body is hidden by default for animation
		jQuery('body').css('opacity', 1);
	}

});





// WEBPACK FOOTER //
// ./assets/scripts/js/voda.js